<label
  [id]="'wzb-toggle-label-' + id"
  [attr.for]="'wzb-toggle-button-' + id"
  class="wzb-toggle-label"
  [class.visually-hidden]="hideLabel"
>
  <ng-content></ng-content>
</label>
<button
  type="button"
  [id]="'wzb-toggle-button-' + id"
  class="wzb-toggle-button"
  role="switch"
  [disabled]="isDisabled"
  [attr.aria-checked]="value"
  [attr.aria-describedby]="'wzb-toggle-label-' + id"
  [class.wzb-toggle-button--marginless]="hideLabel"
>
  <span class="visually-hidden">
    <ng-container *ngIf="!value">Activer</ng-container>
    <ng-container *ngIf="value">Désactiver</ng-container>
  </span>
</button>
